import { useEffect, useMemo, useRef, useState } from 'react';
import { SECOND } from 'core/common/constants';

type Params = {
  itemsCount: number;
  totalDurationInSeconds: number;
};

export const animationDurationMs = 300;

export const useTransitions = ({ itemsCount, totalDurationInSeconds }: Params) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isLastMessage, setIsLastMessage] = useState(false);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const timeoutRef = useRef<NodeJS.Timeout>();

  const delayInMs = useMemo(() => {
    return (totalDurationInSeconds * SECOND) / itemsCount;
  }, [totalDurationInSeconds, itemsCount]);

  useEffect(() => {
    if (isLastMessage) return;

    const cycleMessages = () => {
      setIsVisible(false);

      timeoutRef.current = setTimeout(() => {
        setCurrentMessageIndex((prev) => {
          const nextIndex = prev + 1;

          if (nextIndex === itemsCount - 1) {
            setIsLastMessage(true);
          }

          return nextIndex % itemsCount;
        });

        setIsVisible(true);
      }, animationDurationMs);
    };

    const intervalId = setInterval(() => {
      cycleMessages();
    }, delayInMs);

    return () => {
      clearInterval(intervalId);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [itemsCount, delayInMs, isLastMessage]);

  return {
    isVisible,
    currentMessageIndex,
  };
};
